import {
  ClientFragment,
  useClientQuery,
  useUpdateClientMutation,
} from "@graphql/clients/clients.g";

import {
  ClientForm,
  ClientFormValues,
} from "@components/Forms/ClientForm/ClientForm";

type Props = {
  clientId: string;
  onUpdateClientSuccess?: (data: ClientFragment) => Promise<void> | void;
};

export const UpdateClientForm = ({
  clientId,
  onUpdateClientSuccess,
}: Props) => {
  const clientQuery = useClientQuery({ clientId });
  const updateClientMutation = useUpdateClientMutation();
  const updateClient = updateClientMutation.mutateAsync;

  const client = clientQuery.data?.client ?? undefined;

  const onSubmit = async (values: ClientFormValues) => {
    const data = await updateClient({
      input: {
        id: clientId,
        ...values,
      },
    });

    const client = data?.updateClient?.client;

    if (!client) return;

    await onUpdateClientSuccess?.(client);
  };

  return <ClientForm onSubmit={onSubmit} values={client} submitText="Update" />;
};
